const NS = 'MmfsCarouselBlock';
const CLS = 'mmfsCarouselBlock';

export class MmfsCarouselBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.layouts = {
			Default: '',
			FullContainerWidth: 'fullContainerWidth'
		};
		this.selectedLayout = this.layouts.Default;

		this.$sliderContainer = this.$element.find(`.${CLS}-sliderContainer`);
		this.$carouselItems = this.$element.find(`.${CLS}-item`);
		this.$carouselSlider = this.$element.find(`.${CLS}-slider`);
		this.$carouselImg = this.$element.find(`.${CLS}-item-img`);
		this.sliderNum = this.$element.data(`sliderNum`);
		this.autoSlide = this.$element.data(`autoSlide`);
		if(!this.sliderNum){
			this.sliderNum = 1;
		}

		if(this.sliderNum < 2){
			this.$carouselImg.css('height', 'auto');
		}
		if(this.autoSlide === "False"){
			this.autoSlide = false;
		}
		else{
			this.autoSlide = true;
		}
		// init slider
		this.$carouselSlider.slick({
			dots: true,
			dotsClass: `slick-dots`,
			slidesToShow: this.sliderNum,
			autoplay: this.autoSlide,
  			autoplaySpeed: 5000,
			appendArrows: this.$sliderContainer,
			appendDots: this.$sliderContainer,
			nextArrow: `<button type="button" class="slick-arrow slick-arrow--next"><i class="slick-arrow-icon icon icon--chevron-lg-right"></i></button>`,
			prevArrow: `<button type="button" class="slick-arrow slick-arrow--previous"><i class="slick-arrow-icon icon icon--chevron-lg-left"></i></button>`,
			infinite: false,
			cssEase: 'ease-in-out',
			useTransform: true,
			adaptiveHeight: true,
			responsive: [
				{
				  breakpoint: 768,
				  settings: {
					centerPadding: '50px',
					slidesToShow: 1
				  }
				}
			  ]
		});

		this.carouselArrowButton = this.$element.find(`.slick-arrow`);

		// Set the particular layout
		this.setSelectedLayout();

		// Set the positioning of the carousel elements
		this.adjustCarouselItems();

		// Display the carousel
		this.$carouselItems.css({ visibility: 'visible' });
		$(window).resize(_.debounce(() => {
			this.adjustCarouselItems();
		}, 50));

		this.$images = this.$element.find('img');
		this.totalImages = this.$images.length || 0;
		this.imagesLoaded = 0;

		if(this.totalImages > 0) {
			this.$images.each((index, element) => {
				let imgSrc = $(element).attr('src');
				let objImg = new Image();
				objImg.src = imgSrc;

				objImg.onload = () => {
					this.imagesLoaded++;
					if(this.imagesLoaded === this.totalImages) {
						this.adjustCarouselItems();
					}
				};
			});
		}
	}

	setSelectedLayout() {
		let selectedLayout = this.$element.data('layout');
		let isFound = _.find(this.layouts, (layout) => {
			return layout === selectedLayout;
		});

		if(isFound) {
			this.selectedLayout = selectedLayout;

			if(this.selectedLayout === this.layouts.FullContainerWidth) {
				this.$element.addClass(`${CLS}--fullContainerWidth`);
			}
		}
	}

	adjustCarouselItems() {
		this.adjustArrowVisibility();
		this.assignImageRatio();
		this.adjustArrowPosition();
	}

	assignImageRatio() {
		if(this.sliderNum < 2){
		this.$carouselItems.each((index, item) => {
			let $image = $(item).find(`.${CLS}-item-img`);
			let $padder = $(item).find(`.${CLS}-item-imgContainer-padder`);

			if($image.width() >= $image.height()) {
				$image.addClass(`${CLS}-item-img--horizontal`);
				$image.removeClass(`${CLS}-item-img--vertical`);

				$padder.css({
					paddingTop: $image.height() / $image.width() * 100 + '%'
				});
			}
			else {
				$image.addClass(`${CLS}-item-img--vertical`);
				$image.removeClass(`${CLS}-item-img--horizontal`);

				$padder.css({
					paddingTop: '66%'
				});
			}
		});
		}
	}

	adjustArrowPosition() {
		let imgContainerHeight = this.$element.find(`.slick-active .${CLS}-item-imgContainer`).height();

		this.carouselArrowButton.each((_index, element) => {
			let $arrow = $(element);
			$arrow.css({
				top: `${((imgContainerHeight / 2) - ($arrow.height() / 2))}px`
			});
		});
	}

	adjustArrowVisibility() {
		let $arrows = this.$element.find(`.slick-arrow`);
		if(!($arrows && $arrows.length > 0)) {
			return;
		}

		let previousArrow = this.$element.find(`.slick-arrow--previous`);
		let nextArrow = this.$element.find(`.slick-arrow--next`);

		previousArrow.css({
			display: Math.floor(previousArrow.offset().left) < 0 ? 'none' : 'block'
		});

		nextArrow.css({
			display: (Math.ceil(nextArrow.offset().left + nextArrow.width()) + 1) >= this.getContainerWidth() ? 'none' : 'block'
		});
	}

	getContainerWidth() {
		return $(window).width();
	}
}
